import { collection } from "firebase/firestore";
import { firestore } from "../firebase";

/**
 * Retorna la referencia a una subcollection, versionada o legacy.
 *
 * - syncVersion > 0  → users/{userId}/versions/{N}/{subcollection}
 * - syncVersion == 0  → users/{userId}/{subcollection}  (legacy)
 */
export function getVersionedCollection(userId, subcollection, syncVersion) {
  if (syncVersion && parseInt(syncVersion) > 0) {
    return collection(
      firestore,
      "users",
      userId,
      "versions",
      syncVersion.toString(),
      subcollection
    );
  }
  return collection(firestore, "users", userId, subcollection);
}
